import { Box, FormControl, FormLabel, Select, Switch } from '@chakra-ui/react'
import { getProductFullName } from 'brokertslib/src/enums'
import { createContext, useContext, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { FormGroup } from '../../components/FormGroup'
import { SwitchControl } from '../../components/SwitchControl'
import { RtpcQuery } from '../../dtos/rtpc/RtpcQuery'
import { useGetInsurers, useGetProducts } from '../../hooks/useRtpc'

export const rtpcFilterContext = createContext<RtpcQuery>({} as RtpcQuery)

export const RtpcFilter = ({
  onSubmit,
}: {
  onSubmit: (filter: RtpcQuery) => void
}) => {
  const filterContext = useContext(rtpcFilterContext)
  const methods = useForm({ defaultValues: filterContext })
  const {
    handleSubmit,
    register,
    formState: { isSubmitting },
    watch,
  } = methods

  const { data: productsData } = useGetProducts()
  const { data: insurersData } = useGetInsurers()

  useEffect(() => {
    const subscription = watch(() => handleSubmit(onSubmit)())
    return () => subscription.unsubscribe()
  }, [handleSubmit, watch])

  return (
    <FormProvider {...methods}>
      <Box sx={{ display: 'grid', gap: 4, justifyItems: 'start' }}>
        <FormGroup alignItems={'end'}>
          <FormControl>
            <FormLabel htmlFor="product">Produkt</FormLabel>

            <Select
              isDisabled={isSubmitting}
              width={'80'}
              {...register('product', {
                setValueAs: (value) => (value ? value : undefined),
              })}
            >
              <option value="">Všechny produkty</option>
              {productsData?.data.map((product) => (
                <option key={product} value={product}>
                  {getProductFullName(product)}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel htmlFor="insurer">Pojišťovna</FormLabel>

            <Select
              width={'80'}
              {...register('insurer', {
                setValueAs: (value) => (value ? value : undefined),
              })}
            >
              <option value="">Všechny pojišťovny</option>
              {insurersData?.data.map((insurer) => (
                <option key={insurer.insurerId} value={insurer.insurerId}>
                  {insurer.insurer}
                </option>
              ))}
            </Select>
          </FormControl>

          <SwitchControl mb={1}>
            <Switch id="onlyValid" {...register('onlyValid')} />
            <FormLabel htmlFor="onlyValid" variant="switch" fontSize={'md'}>
              Pouze platné
            </FormLabel>
          </SwitchControl>

          <SwitchControl mb={1}>
            <Switch id="showDeleted" {...register('showDeleted')} />
            <FormLabel htmlFor="showDeleted" variant="switch" fontSize={'md'}>
              Zobrazit smazané
            </FormLabel>
          </SwitchControl>
        </FormGroup>
      </Box>
    </FormProvider>
  )
}
